<template>
  <shipment-payment-error-view
    class="shipment-payment-dialog-payment-error-view"
    @retry="$emit('retry')"
    @close="$emit('close')"
  />
</template>

<script>
  import ShipmentPaymentErrorView from '@/views/Shippers/components/ShipmentPaymentErrorView/index.vue'
  /**
   * @module component - ShipmentPaymentDialogPaymentErrorView
   * @emits close
   * @emits retry
   */
  export default {
    name: 'ShipmentPaymentDialogPaymentErrorView',
    components: {
      ShipmentPaymentErrorView
    }
  }
</script>
